// @flow
import * as React from 'react';
import styled, { css } from 'styled-components';
import InjuredStatusIcon from '../Icons/Injured';
import Bye from '../Icons/Bye';
import Emergency from '../Icons/Emergency';
import Uncertain from '../Icons/Uncertain';
import NotSelected from '../Icons/NotSelected';
import Selected from '../Icons/Selected';
import Suspended from '../Icons/Suspended';

const style = css`
	display: inline-block;
	margin-right: .5em;
	margin-bottom: -1px;
`;

const StatusPlaying = styled(Selected)`
	${style}
`;

const StatusNotSelected = styled(NotSelected)`
	${style}
`;

const StatusUncertain = styled(Uncertain)`
	${style}
`;

const StatusBye = styled(Bye)`
	${style}
`;

const StatusReserve = styled(Emergency)`
	${style}
`;

const StatusInjured = styled(InjuredStatusIcon)`
	${style}
`;

const StatusSuspended = styled(Suspended)`
	
`;

const mapStatusToComponent = {
	"playing": StatusPlaying,
	"not-playing": StatusNotSelected,
	"injured": StatusInjured,
	"uncertain": StatusUncertain,
	"is-bye": StatusBye,
	"reserve": StatusReserve,
	"suspended": StatusSuspended
};

type Props = {
	status?: string,
	is_bye: boolean,
}

const NullComponent = () => null;

export const PlayerStatus = ({ status, is_bye }: Props) => {
	if(!status) {
		return null;
	}

	if (is_bye) {
		// Overwrite the status with bye JIC it doesn't
		// end up coming from BE
		status = 'is-bye';
	}

	const Component = mapStatusToComponent[status] || NullComponent;

	return <Component className={status} />;
};

export default PlayerStatus;


// WEBPACK FOOTER //
// ./src/components/PlayerStatus/index.js